import axios from 'axios';

import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { ECheckRequest, ICheckRequest, IProcessCheck } from './interfaces';

export const CheckRequestAPI = {
  PATCH: async(path: string, data: ICheckRequest, checkRequestType: number) => {
    data.checkRequestType = String(checkRequestType);
    data.assetTag = data.assetTag || data.assetDesc || '';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { sellerRefundAmount, customerRefundAmount, cancellationDate, ...restCheck } = data;
    const cutAllPayload = {
      ...restCheck,
      customerAmountRefund: data?.customerRefundAmount,
      sellerAmountRefund: data?.sellerRefundAmount,
      cancelledDate: data?.cancellationDate,
    };

    await axios.patch(path, cutAllPayload);
  },
  POST: async(path: string, data: ICheckRequest, checkRequestType: number) => {
    path = `${path}?checkRequestType=${checkRequestType}`;
    await axios.post(path, data);
  },
};

export const requestProcessCheck = async(data: IProcessCheck) => {
  const path = `/${SERVICES.ACCOUNTING}/checkrequest/processcheck`;
  await axios.post(path, data);
};

export const requestPDF = async(id: string, checkRequestType: ECheckRequest) => {
  try {
    const response = await axios.get<string>(`/${SERVICES.ACCOUNTING}/checkRequest/${id}/pdf?checkRequestType=${checkRequestType}`);

    return response.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
